import { render, staticRenderFns } from "./PositionForm.vue?vue&type=template&id=9e08f1e2&scoped=true"
import script from "./PositionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionForm.vue?vue&type=style&index=0&id=9e08f1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e08f1e2",
  null
  
)

export default component.exports